import React, {useEffect, useState} from 'react';
import {Grid, Checkbox, FormHelperText, FormControlLabel} from "@mui/material";
import {API} from "../framework/api";

export function CompetenceArea(props) {
  const [competences, setCompetences] = useState([]);
  const [competenceList, setCompetenceList] = useState('');

  useEffect(() => {
    API.getAPI().get_competences().then((response)=> {
      setCompetences(response.data);
    });
  }, []);

  useEffect(() => {
    setCompetenceList(props.competences);
  }, [props.competences]);

  const hasCompetence = (id) => {
    let hasIt = false;
    if (competenceList.length > 0) {
      competenceList.split(",").forEach((c) => {
        if (parseInt(c) === parseInt(id)) hasIt = true;
      });
    }

    return hasIt;
  };

  const handleChange = (e) => {
    const id = parseInt(e.target.name);

    if (props.onChange instanceof Function) {
      props.onChange(id, !hasCompetence(id));
    }
  };

  const addCompetence = () => {
    let name = prompt("Ange ett namn på kompetensen", "");

    if (name !== null) {
      API.getAPI().add_competence(name).then((response)=> {
        setCompetences(response.data);
      });
    }
  }

  return (
    <Grid container={true} spacing={1}>
      {competences.map((competence) => (
        <Grid item xs={6} sm={4}>
          <FormControlLabel
            control={
              <Checkbox checked={hasCompetence(competence.id)} disabled={props.readOnly} onChange={handleChange} name={competence.id} />
            }
            label={competence.competence}
          />
        </Grid>
      ))}
      {props.readOnly ? null :
        <Grid item xs={12} sm={12}>
          <FormHelperText className={"u-clickable"} onClick={() => {addCompetence()}}>Lägg till en kompetens du saknar &raquo;</FormHelperText>
        </Grid>
      }
    </Grid>
  );
}
